import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import GuideRu from './eventCreationGuide/ru';
import GuideEn from './eventCreationGuide/en';
import GuideDe from './eventCreationGuide/de';
import GuideEs from './eventCreationGuide/es';
import GuideIt from './eventCreationGuide/it';
import GuideFr from './eventCreationGuide/fr';
import GuideCs from './eventCreationGuide/cs';
import './EventCreationGuide.css';

// Инструкция по созданию событий: текст и скриншоты на каждом языке интерфейса.
// Скриншоты лежат в public/guides/events/<lang>/ и сняты с формы
// CreateEditEvent: поменялась форма — переснять затронутые кадры на всех языках.
// Новый язык интерфейса: файл в eventCreationGuide/, строка здесь и свои кадры
const GUIDES = {
  ru: GuideRu,
  en: GuideEn,
  de: GuideDe,
  es: GuideEs,
  it: GuideIt,
  fr: GuideFr,
  cs: GuideCs
};

const EventCreationGuide = () => {
  const navigate = useNavigate();
  const { t, language } = useLanguage();
  const GuideContent = GUIDES[language] || GuideEn;

  return (
    <div className="event-guide-page">
      <div className="event-guide-container">
        <button type="button" className="event-guide-back" onClick={() => navigate('/events')}>
          ← {t('events.guide.back')}
        </button>

        <div className="event-guide-header">
          <h1>{t('events.guide.title')}</h1>
        </div>

        <GuideContent />
      </div>
    </div>
  );
};

export default EventCreationGuide;
